import {type TranslationObject} from '@colonist/i18n'
import {type ActionStatus} from '@colonist/game-base-types'
import {type TradeResponseStatus, type PlayerColor, type TradeId, type CardEnum} from '@colonist/game-states'

export interface TradeError {
    error: TranslationObject
    payload?: TradeErrorPayload
}

export interface TradeErrorPayload {
    highlightCards?: {
        cardsToHighlight: CardEnum[]
        locations: TradeErrorHighlightLocationEnum[]
    }
    highlightTrade?: {
        tradeIds: TradeId[]
        autoAcceptOffer?: boolean
    }
    isPlayerTradeButtonDisabled?: boolean
    isBankTradeButtonDisabled?: boolean
    hasBankTradeRatioError?: boolean
}

export enum TradeErrorHighlightLocationEnum {
    ProposalWanted,
    ProposalOffered,
    WantedSelector,
    OfferedSelector
}

export enum TradeActions {
    Accept,
    Reject,
    CounterOfferCreating,
    CounterOfferCreatedOrCanceled
}

export interface TradeCreationData {
    readonly creator: PlayerColor
    readonly isBankTrade: boolean
    readonly counterOfferInResponseToTradeId: TradeId | undefined
    readonly offeredResources: CardEnum[]
    readonly wantedResources: CardEnum[]
    readonly forcedResponse?: TradeResponseStatus
}

export interface TradeResponse {
    readonly id: TradeId
    readonly response: TradeActions
}

export interface TradeExecutionData {
    readonly tradeId: TradeId
    readonly playerToExecuteTradeWith: PlayerColor
}

export interface TradeActionStatus extends ActionStatus {
    displayActionButton: boolean
}

export interface TradePlayerResponseStatus {
    readonly player: PlayerColor
    responseStatus: TradeResponseStatus
}

export interface TradePlayerCreatingCounterOfferStatus {
    readonly player: PlayerColor
    isCreatingCounterOffer: boolean
}

// Feb 17, 2021. Jeff: I didn't refactor this out yet. Please don't use.
export interface GiveWantTradeFormat {
    givingResources: CardEnum[]
    wantResources: CardEnum[]
    target: PlayerColor
}

export enum TradeOfferOpponentDisplay {
    AvatarContainer,
    ResponseButtons,
}

export interface TradeCounterOffer {
    readonly tradeId: TradeId
    readonly receivingResources: CardEnum[]
    readonly givingResources: CardEnum[]
}
